import { useQuery } from "@apollo/client/react";
import type { ClientModel } from "../../../models/ClientModel";
import GET_CLIENT_CREDIT_DATA from "../../queries/client/getClientCreditData";

export const useClientCreditData = (clientIdentifier: string) => {
  const { data, error, loading, refetch } = useQuery<{ client: ClientModel }>(
    GET_CLIENT_CREDIT_DATA,
    {
      variables: { clientIdentifier },
    },
  );
  return { clientCreditData: data?.client, error, loading, refetch };
};
